import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { borderGrey } from 'common/constants/colors';
import { makeApiRequestAndHandleError, simpleFetch } from 'common/utils/http';
import { ATTRIBUTE_TYPE_PROPTYPE } from 'common/constants/commonPropTypes';
import PaneHeader from './PaneHeader';
import TypeInfoPaneItem from './TypeInfoPaneItem';
import { AccessRuleGroup, AttributeType } from '../../../common/constants/types';

interface Props {
  attrType: AttributeType;
  paneName: string;
}

const formatAccessRuleGroup = (allGroups: AccessRuleGroup[], id?: number) => {
  const group = allGroups.find(g => g.id === id) as AccessRuleGroup;
  return `${group.id} - ${group.name}`;
};

const TypeInfoPane = ({ attrType, paneName }: Props) => {
  const [attrTypeInfo, setAttrTypeInfo] = useState<AttributeType | undefined>(undefined);
  const [accessRuleGroups, setAccessRuleGroups] = useState<AccessRuleGroup[]>([]);
  useEffect(() => {
    if (!attrType) {
      return;
    }
    makeApiRequestAndHandleError(async () => {
      simpleFetch(`/api/v1/attribute-types/${attrType.name}`).then(resp => setAttrTypeInfo(resp));
      simpleFetch('/api/v1/access-rule-groups').then(args => setAccessRuleGroups(args));
    });
  }, [attrType]);

  const attrTypeItems =
    attrTypeInfo !== undefined && accessRuleGroups.length !== 0
      ? [
        { name: 'Name', value: attrTypeInfo.name },
        { name: 'Datatype', value: attrTypeInfo.datatype },
        { name: 'Description', value: attrTypeInfo.description },
        { name: 'Listable', value: attrTypeInfo.listable.toString() },
        {
          name: 'Can Modify Access Rule Group',
          value: formatAccessRuleGroup(
            accessRuleGroups,
            attrTypeInfo.can_modify_access_rule_group
          ),
        },
        {
          name: 'Can View Access Rule Group',
          value: formatAccessRuleGroup(accessRuleGroups, attrTypeInfo.can_view_access_rule_group),
        },
        { name: 'Singleton', value: attrTypeInfo.singleton.toString() },
        { name: 'Sort Order', value: attrTypeInfo.sort_order.toString() },
        {
          name: 'Allow Passthrough Modify',
          value: (attrTypeInfo.allow_passthrough_modify_access_rule_group ?? false).toString(),
        },
      ]
      : [];

  return (
    <div style={{ borderRight: `solid 1px ${borderGrey}`, width: '25vw' }}>
      <PaneHeader paneName={paneName} />
      <div style={{ margin: '10px' }}>
        {attrTypeItems.map(info => (
          <TypeInfoPaneItem infoName={info.name} infoVal={info.value} key={info.name} />
        ))}
      </div>
    </div>
  );
};
TypeInfoPane.propTypes = {
  attrType: ATTRIBUTE_TYPE_PROPTYPE,
  paneName: PropTypes.string.isRequired,
};
TypeInfoPane.defaultProps = { attrType: null };

export default TypeInfoPane;
